// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1T7K2","productName":"Table_productName__2erqh"};